import request from '@/utils/request'
export function info(domain) {
  return request({
    url: `https://api.mamale.vip/api/tenants/domain?domain=${domain}`
  })
}





// WEBPACK FOOTER //
// ./src/api/site.js